module.exports = __webpack_public_path__ + "img/index02.1bdfaa7d.png";